/**
 * 竞品列的**配色**。
 *
 * 竞品列 2026-09-16 起随配置版本存（cfg_main_rival），数值在建筑页 / 星级表逐格逐星手填；
 * 这里只剩画列头小圆点用的调色板，不参与任何数值。
 */
export interface RivalDef { id: string; name: string; color: string }

export const RIVAL_COLORS = ["#e6a23c", "#67c23a", "#f56c6c", "#79bbff", "#73767a", "#b37feb", "#13c2c2", "#eb2f96"];
export const rivalColor = (i: number): string => RIVAL_COLORS[i % RIVAL_COLORS.length];
